<div id="tv-wrapper">
  <div class="tv-container">
    <div class="chart-holder">
      <app-mempool-graph
        [template]="'advanced'"
        [height]="600"
        [left]="60"
        [right]="10"
        [data]="statsSubscription$ | async"
        [showZoom]="false"
      ></app-mempool-graph>
    </div>
    <div class="blockchain-wrapper" [dir]="timeLtr ? 'rtl' : 'ltr'" [class.time-ltr]="timeLtr">
      <div class="position-container">
        <span>
          <div class="blocks-wrapper">
            <app-mempool-blocks></app-mempool-blocks>
            <app-blockchain-blocks></app-blockchain-blocks>
          </div>
          <div id="divider"></div>
        </span>
      </div>
    </div>
  </div>
</div>
